import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_AU',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '1832d253-8f81-45df-a58c-860508fc3439',
  ''
);
